export const riceMillOption = [
    "COLPER-CM201",
    "PCT201",
    "CR100",
    "CCS100",
    "SB100-SB200",
  ];
  
  export const multifunctionOption = ["MFG250", "LG500S", "LG600S"];
  
  export const longTailOption = [
    "T-RM",
    "T-RM HEAVY LOAD",
    "T-RL",
    "DIRECT BIG",
    "DIRECT MID",
    "FW-RV LONG TAIL",
    "FW-RV IN BROAD",
  ];
  
  export const agricutureOption = [
    "WC155",
    "FC255 30-1",
    "FC255 18-1",
    "FC255 9-1",
    "CT155",
    "CACAO",
  ];
  